import _ from 'underscore';

import ProteinConstants from './AaSequenceConstants';

// Validates whether AA sequence is a string composed of elements from amino acid single letter
// abbreviations
function areAminoAcidsValid(aminoAcids: string): boolean {
  // eslint-disable-next-line no-restricted-syntax
  return _.every(aminoAcids.toUpperCase(), (aa) => ProteinConstants.ALL_AMINO_ACIDS.includes(aa));
}

export default areAminoAcidsValid;
